import { ApplicationLanguages } from "../language/language"

export interface AuthModel{
    userDbId: number,
    token: string,
    expiryUtc: string,
    isLoginSuccessful: boolean,
    passwordChangeRequiredDays: number,
    agentName: string,
    username:string,
    isParticipant:boolean,
    participantLastActiveLanguage:number,
    showBBLogo:boolean,
    authDomain:string
}

export function defaultAuthModelValues():AuthModel{
  return {
    userDbId: 0,
    token: '',
    expiryUtc: '',
    isLoginSuccessful: false,
    passwordChangeRequiredDays: 0,
    agentName: '',
    username: '',
    isParticipant: false,
    participantLastActiveLanguage: 0,
    showBBLogo: true,
    authDomain: ''
  }
}
